<template>
  <carousel-widget v-if="panel.panel_widget_id === 1"></carousel-widget>
</template>

<script>
import CarouselWidget from './DashboardWidgets/CarouselWidget.vue';

export default {
  name: 'HeadlineCardComponent',
  components: {
    CarouselWidget,
  },
  props: ['panel'],
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  created() {
  },
};
</script>
<style scoped>

</style>
